var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { "data-qa": "skeleton-blog-post-list" } },
    _vm._l(_vm.itemsCount, function (item) {
      return _c(
        "div",
        { key: item },
        [
          _c(
            "skeleton-wrapper",
            { staticClass: "_mt-3", attrs: { "has-animation": true } },
            [
              _c("skeleton-line", {
                staticClass: "gfu-animation-pulse",
                attrs: { height: 40 },
              }),
              _vm._v(" "),
              _c("skeleton-line", {
                staticClass: "gfu-animation-pulse _mt-1",
                attrs: { height: 15 },
              }),
              _vm._v(" "),
              _c("skeleton-line", {
                staticClass: "gfu-animation-pulse _mt-2",
                attrs: { height: 20 },
              }),
              _vm._v(" "),
              _c("skeleton-line", {
                staticClass: "gfu-animation-pulse _mt-2",
                attrs: { height: 14 },
              }),
            ],
            1
          ),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }